import React from "react";
import styled from "styled-components";
import male from "../../assets/homeAssets/male.png";
import female from "../../assets/homeAssets/female.png";
import unisex from "../../assets/homeAssets/unisex.png";
import { Link } from "react-router-dom";

const Categories = () => {
  return (
    <Container>
      <Link to={"/produktet/male-perfumes"} className="item">
        <img src={male} alt="" />
      </Link>
      <Link to={"/produktet/female-perfumes"} className="item">
        <img src={female} alt="" />
      </Link>
      <Link to={"/produktet/unisex-perfumes"} className="item">
        <img src={unisex} alt="" />
      </Link>
    </Container>
  );
};
const Container = styled.div`
  padding: 5em 7%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1em;
  .item {
    width: 30%;
    cursor: pointer;
    transition: 0.4s;
    img {
      border-radius: 30px;
      width: 100%;
    }
    &:hover {
      filter: brightness(1.1);
    }
  }
  @media (max-width: 650px) {
    flex-wrap: wrap;
    .item {
      width: 48%;
    }
  }
  @media (max-width: 470px) {
    .item {
      width: 98%;
    }
  }
`;

export default Categories;
